<template>
  <main class="bg-white py-10" ref="sectionRef">
    <div class="container mx-auto px-4">
      <!-- Title -->
      <h2 class="text-center text-3xl font-bold mb-8 text-yellow mt-8">
        Our Board of Directors
      </h2>
      <hr
        class="h-0.5 bg-yellow mx-auto rounded-lg border-none transition-all duration-500 ease-in-out"
        :class="isActive ? 'w-60' : 'w-0'"
      />

      <!-- Top Director (Dr. Musa) -->
      <div class="flex justify-center mb-10">
        <div class="w-72 text-center">
          <div class="bg-white shadow-lg rounded-lg overflow-hidden">
            <img
              class="w-full h-96 object-cover"
              src="../assets/images/MR MUS.png"
              alt="Dr. Musa Tarimbuka"
            />
          </div>
          <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">
            Dr. Musa Tarimbuka
          </h4>
          <p class="text-gray-600">Chairman</p>
        </div>
      </div>

      <!-- Other Directors (Grid Layout) -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        <div
          v-for="(director, index) in directors"
          :key="index"
          class="text-center"
        >
          <div class="bg-white shadow-lg rounded-lg overflow-hidden">
            <img
              class="w-full h-[30vw] object-cover"
              :src="director.image"
              :alt="director.name"
            />
          </div>
          <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">
            {{ director.name }}
          </h4>
          <p class="text-gray-600">{{ director.position }}</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";

export default {
  setup() {
    const isActive = ref(false);
    const sectionRef = ref(null);

    const observer = new IntersectionObserver(
      ([entry]) => {
        isActive.value = entry.isIntersecting;
      },
      { threshold: 0.5 }
    );

    onMounted(() => {
      if (sectionRef.value) observer.observe(sectionRef.value);
    });

    onUnmounted(() => {
      observer.disconnect();
    });

    return { isActive, sectionRef };
  },
  data() {
    return {
      directors: [
        {
          name: "Mr. Adewale Fagbenro",
          position: "Non Executive Director",
          image: require("../assets/images/MR WALE.png"),
        },
        {
          name: "Mr. Sam Hart",
          position: "Non Executive Director",
          image: require("../assets/images/sam.jpeg"),
        },
        {
          name: "Mrs. Lisa B. Mshelia",
          position: "Non Executive Director",
          image: require("../assets/images/MRS LISA MSHELIA.png"),
        },
        {
          name: "Mr. Folahanmi Ogunbodede",
          position: "Non Executive Director",
          image: require("../assets/images/MR FOLA.png"),
        },
      ],
    };
  },
};
</script>

<style scoped>
.board-style {
  font-family: Caveat;
}
@keyframes underlineExpand {
  from {
    width: 0;
  }
  to {
    width: 15rem;
  }
}

.animate-underline {
  animation: underlineExpand 1s ease-out forwards;
}
</style>
